import {FC, useState} from 'react'
import {useDispatch} from 'react-redux'
import {UploadAvatar, setAvatar} from 'entities/user'
import {EditButton} from 'features/buttons/editButton'
import {GetDirectUploadUrlPhoto, UploadMediaToBucket} from 'shared/api/images'
import {Loader} from 'shared/ui/loader'

type EditButtonProps = {
  className?: string
}

export const EditAvatarButton: FC<EditButtonProps> = ({className}) => {
  const dispatch = useDispatch()
  const [isLoading, setIsLoading] = useState(false)

  const onSave = async (file: File) => {
    setIsLoading(true)

    try {
      const {data: uploadUrls} = await GetDirectUploadUrlPhoto({
        count: 1,
        mediaType: 'avatar'
      })
      const [{uploadUrl, key}] = uploadUrls

      await UploadMediaToBucket(uploadUrl, file)

      const {data: avatar} = await UploadAvatar(key)
      dispatch(setAvatar(avatar.image.url))
    } catch (error) {
      console.error('error: ', error)
    } finally {
      setIsLoading(false)
    }
  }

  const editAvatarHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!(event.target.files && event.target.files.length > 0)) return
    onSave(event.target.files[0])
    event.target.value = ''
  }

  return (
    <>
      {isLoading ?
        <div>
          <Loader innerColor='white' />
        </div>
        :
        <EditButton className={className} onChange={editAvatarHandler} />
      }
    </>
  )
}
